<template>
  <div class="btn_tools">
    <!--    {{ activeItem.length }}-->
    <!--    {{ folderMap }}-->
    <!--    {{ fileList }}-->
    <div style="display: flex">
      <el-button v-if="type===5" size="small" :icon="StarFilled" color="#409eff" plain @click="collectTo('1')"
                 style="margin-right: 12px;">
        {{ $t("common.cds16") }}
      </el-button>
      <!--文件上传-->
      <el-dropdown v-if="type===1" @command="handleUploadModeSelect" style="margin-right: 12px;">
        <el-button size="small" type="primary" :icon="UploadFilled">
          {{ $t("common.upload") }}
          <el-icon class="el-icon--right">
            <arrow-down/>
          </el-icon>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="file">{{ $t('common.file.upload') }}</el-dropdown-item>
            <el-dropdown-item command="folder">{{
                $t('common.file.upload.group')
              }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <!-- 隐藏的上传组件 -->
      <ElUpload
          ref="uploadRefCom"
          class="upload-demo"
          style="display: none"
          :action="action"
          :headers="{
            'X-Access-Token': token,
          }"
          :show-file-list="false"
          @change="handleChange"
          :on-progress="onProgress"
          :before-upload="beforeUpload"
          :on-error="handleUploadError"
          :on-success="handleUploadSuccess"
          multiple
      >
        <!-- 用这个插槽包住 input，用于 DOM 获取 -->
        <template #trigger>
          <span></span>
        </template>
      </ElUpload>
      <el-button size="small" v-if="type===1" :icon="FolderAdd" plain color="#409eff" @click="addNewDir">
        {{ $t("common.newfolder") }}
      </el-button>
      <el-button size="small" v-if="type===1 || type===2 || type===5" :icon="Download" plain color="#409eff"
                 @click="downloadTargetFile" :loading="downloadLoading">
        {{ $t("common.download") }}
      </el-button>
      <el-button size="small" v-if="type===1 || type===5" :icon="DeleteFilled" plain color="#409eff"
                 @click="deleteTargetFile('2')">
        {{ $t("common.delete") }}
      </el-button>
      <el-button size="small" v-if="type===1 || type===5" :icon="Share" plain color="#409eff"
                 @click="sharedTargetFile(_,'1')">
        {{ $t("common.joint.with") }}
      </el-button>
      <el-button size="small" v-if="type===1 || type===5" :icon="Promotion" plain color="#409eff" @click="shareLink">
        {{ $t("common.share") }}
      </el-button>
      <el-button size="small" v-if="type===1 || type===5" :icon="Rank" plain color="#409eff" @click="moveTo(_,'1')">
        {{ $t("common.move.to") }}
      </el-button>
      <el-button size="small" v-if="type===1" :icon="StarFilled" plain color="#409eff" @click="collectTo('2')">
        {{ $t("common.cds15") }}
      </el-button>
      <el-button size="small" v-if="type===1" :icon="CopyDocument" plain color="#409eff" @click="moveTo(_,'3')">
        {{ $t("common.copy.to") }}
      </el-button>
      <el-button size="small" v-if="type===2" :icon="Tickets" plain color="#409eff" @click="moveTo(_,'2')">
        {{ $t("common.transfer.to") }}
      </el-button>
      <el-button size="small" v-if="type===3" :icon="Setting" type="primary" @click="sharedTargetFile(_,'2')"
                 :disabled="activeItem.length>1">{{ $t("common.setting.joint") }}
      </el-button>
      <el-button size="small" v-if="type===3" :icon="DocumentDelete" type="primary" @click="cancelPublicShare">
        {{ $t("common.cancel.joint") }}
      </el-button>
      <el-button size="small" v-if="type===4" :icon="DocumentDelete" type="primary" @click="cancelShare"
                 :loading="cancelLoading">
        {{ $t("common.cancel.share") }}
      </el-button>
      <el-button size="small" v-if="type===6" :icon="RefreshLeft" type="primary" @click="deleteTargetFile('1')">
        {{ $t("common.file.restore") }}
      </el-button>
      <el-button size="small" v-if="type===6" :icon="CircleClose" type="danger" @click="deleteTargetFile('3')">
        {{ $t("common.file.delete") }}
      </el-button>
      <el-button size="small" v-if="type===6" :icon="Delete" type="danger" @click="deleteTargetFile('4')">
        {{ $t("common.recycle.clean") }}
      </el-button>
    </div>
    <div style="width: 310px;display: flex;flex-direction: row">
      <div style="margin-right: 20px;">
        <el-input
            v-model="searchFile"
            class="responsive-input"
            clearable
            :placeholder="$t('common.please.input')"
            size="small"
            @keyup.enter="getFileList"
            @clear="getFileList"
        >
          <template #prefix>
            <el-icon class="el-input__icon">
              <search/>
            </el-icon>
          </template>
        </el-input>
      </div>
      <div class="file_them">
        <div :class="[isSelect===1?'isSelect':'','switch']" @click="handleClickChange(1)">
          <img v-show="isSelect===1" style="width: 18px;height: 18px" src="@/assets/FileCloud/grid_select.svg"/>
          <img v-show="isSelect!==1" style="width: 18px;height: 18px" src="@/assets/FileCloud/grid.svg"/>
        </div>
        <div :class="[isSelect===2?'isSelect':'','switch']" @click="handleClickChange(2)">
          <img v-show="isSelect===2" style="width: 15px;height: 15px" src="@/assets/FileCloud/list_select.svg"/>
          <img v-show="isSelect!==2" style="width: 15px;height: 15px" src="@/assets/FileCloud/list.svg"/>
        </div>
      </div>
    </div>
  </div>
  <div class="file_all">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-for="(item, index) in pathArray" :key="item.path"
                          @click.native.stop="handleClick(item, index)">
            <span
                style="cursor: pointer">{{ item.text }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="inner_out_box">
    <div :class="type!==6?'box_table':'box_table_sp'"
         @dragover.prevent
         @drop.prevent="handleDrop"
         v-loading="switchingLoading"
    >
      <el-table
          v-if="isSelect===2"
          ref="multipleTableRef"
          :data="tableData"
          @selection-change="handleSelectionChange"
          v-loading="tableLoading"
          @row-click="selectClickEvent"
          @selectionChange="selectCheckbox"
          :row-key="row => row.id"
          :cell-style="rowClassName"
          :header-cell-style="headerClassName"
          :row-style="{height: '30px'}"
      >
        <!--          v-el-table-infinite-scroll="handleTableScroll"-->
        <!--        :key="refresh"-->
        <!--        :infinite-scroll-disabled="disabled"-->
        <!--          @row-dblclick="selectTargetDetail"-->
        <el-table-column type="selection" width="60" :reserve-selection="true" fixed="left"/>
        <el-table-column prop="fileName" :label="$t('common.file.name')" class="file_names">
          <template #default="{row}">
            <!--            如果是文件-->
            <div v-if="row.isFolder===1" style="display: flex;align-items: center;">
              <FileIcon :fileExtend="row?.fileExtend?.toLocaleLowerCase()"
                        :fileUrl="row?.fileExtendPath" :size="25"
                        :isAbbreviation="true"></FileIcon>
              <el-button v-if="type!==6 && imgFormat.includes(row?.fileExtend?.toLocaleLowerCase())" link
                         class="pointer"
                         style="margin-left: 10px;"
                         @click.native.stop="showTargetFile(row)">
                <span
                    style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;width: 100%;max-width: 450px;line-height: 20px;">
                  {{
                    row.fileName
                  }}
                </span>
              </el-button>
              <el-button v-else link class="pointer"
                         style="margin-left: 10px;">
               <span
                   style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;width: 100%;max-width: 450px;line-height: 20px;">
                  {{
                   row.fileName
                 }}
                </span>
              </el-button>
            </div>
            <div v-if="row.isFolder===2" style="display: flex;align-items: center;">
              <span style="display: block;height: 24px" class="icon"><i aria-label="图标: folder"
                                                                        class="anticon anticon-folder"
                                                                        style="color: rgb(41, 182, 246); font-size: 24px;"><svg
                  viewBox="64 64 896 896" data-icon="folder" width="1em" height="1em" fill="currentColor"
                  aria-hidden="true" focusable="false" class=""><path
                  d="M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z"></path></svg></i></span>
              <el-button link type="primary" class="pointer"
                         style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;width: 100%;max-width: 450px;justify-content: flex-start !important;margin-left: 10px;line-height: 20px;"
                         @click.native.stop="enterDirectory(row)">
                {{ row.fileName }}
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="type===1||type===3||type===5" width="40" style="position: relative">
          <template #default="scope">
            <template v-if="scope.row.isFolder!==2">
              <img v-if="scope.row.isHide===2" @click.stop="() => handleSettingStress(scope.row)"
                   class="pointer flags_f"
                   style="width: 14px;height: 14px"
                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAZ1JREFUOE+dk71LXEEUxc+Z997uGtC1sZD8A4ql1T5UDNq4EE38gKQTAzZJl04LNQnYCHYRCyX1ypLdLNFKUPzKH5BCLZZUESWEpIr6ZubKewmyK7v64pRzz/1x7rkzRJ0j+e5W7doNCFLGMJsa2S3XkrIeQBf9FRFOhHUSH92hveHYACllHmrDMsDE3yaxVktHcvTg8CakpoOg6C9A+LpSTMqqO7T/oiZAcv3pIPWnXRlpI9lhiVfh7DfEmsCSFfuVcI5dyyOO7JwwKPpvIZgCqOrlccv9InXB/yVg+h7NIPCbQcFfAzh6T8AHSi7TYBJOSSB9/wMhkHdOz59HW5BS5wNtUp8B9MaE5N2094yPtsJg/20615k2ieRPuStMQeAmmxqZ3biIHtk1YL27RV/aszgOXMdr4eOtH1WAoOj3QLgdBwCler3BnUh77cB86pq0VpbjAJTiS2dw9321g0LXNCDvKgBHpMwCyojYOYDtFbU33pO9meoMog+kNgkkKZxXze5qmHK0pdyYY7zv4yCmBbjQYgYann75FtauADgOlbK39b/7AAAAAElFTkSuQmCC"/>
              <img v-else class="pointer flags_f"
                   style="width: 14px;height: 14px"
                   @click.stop="() => handleSettingStress(scope.row)"
                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAY5JREFUOE+dk7FLW1EUxr9zH7GtIJkcpOS+vClK/oeS4KRjcdBNWuhSN7c6tNZCl0K3ioPSvYiDFCcH/wcHI+SR3BvywJRitxjfu195wYYYEnz2jPd853e/e865ggnRaDTmlFInJJ8CWPZ9PxwnlUkAY8w+yVdpXkSOtNYvMwOstc+TJAlFZOquyDnnykEQXIxCxjowxnwhuTksFpEDrfXrsYB6vZ5XSi14njcPoExyA0D69uGIAewCOFdKXSZJUisWi5EYY3ZIvgOgJvVj0jnJr9JsNq8B5B9bfKf/kwJ+AFj5H4CIfBdr7TPn3DGAxUdCDjudzlp/Cu12ezqO458kKxkhh1rrVRGJB2NMJ5HL5X6TfKiZt1rrGRG56S/ZvxujKJrt9XpXWRx0u93ZUqn06x7AGPOC5FkWgFKqUigU+tqBA2vtG+fcXhaAiLzVWn8bdbBF8tMQoCYiH0gmALYBLAzlPvq+/37UQfqBTkXkCYDPYRgeVKvVdH1B0mu1WuvOuS0AN865pSAIGmnuL4BAqYD60aJ1AAAAAElFTkSuQmCC"/>
            </template>
          </template>
        </el-table-column>
        <el-table-column v-if="type===1|| type===3||type===5" width="50">
          <template #default="{row}">
            <el-dropdown>
              <el-button class="sp_btn"
                         :icon="MoreFilled"></el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <!--                  <el-dropdown-item v-if="type===1||type===3||type===5" @click.stop="() => handleSettingStress(row)">-->
                  <!--                    <template v-if="row.isFolder!==2">-->
                  <!--                      <img v-if="row.isHide===2"-->
                  <!--                           class="pointer flags_f"-->
                  <!--                           src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAZ1JREFUOE+dk71LXEEUxc+Z997uGtC1sZD8A4ql1T5UDNq4EE38gKQTAzZJl04LNQnYCHYRCyX1ypLdLNFKUPzKH5BCLZZUESWEpIr6ZubKewmyK7v64pRzz/1x7rkzRJ0j+e5W7doNCFLGMJsa2S3XkrIeQBf9FRFOhHUSH92hveHYACllHmrDMsDE3yaxVktHcvTg8CakpoOg6C9A+LpSTMqqO7T/oiZAcv3pIPWnXRlpI9lhiVfh7DfEmsCSFfuVcI5dyyOO7JwwKPpvIZgCqOrlccv9InXB/yVg+h7NIPCbQcFfAzh6T8AHSi7TYBJOSSB9/wMhkHdOz59HW5BS5wNtUp8B9MaE5N2094yPtsJg/20615k2ieRPuStMQeAmmxqZ3biIHtk1YL27RV/aszgOXMdr4eOtH1WAoOj3QLgdBwCler3BnUh77cB86pq0VpbjAJTiS2dw9321g0LXNCDvKgBHpMwCyojYOYDtFbU33pO9meoMog+kNgkkKZxXze5qmHK0pdyYY7zv4yCmBbjQYgYann75FtauADgOlbK39b/7AAAAAElFTkSuQmCC"/>-->
                  <!--                      <img v-else class="pointer flags_f"-->
                  <!--                           src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAY5JREFUOE+dk7FLW1EUxr9zH7GtIJkcpOS+vClK/oeS4KRjcdBNWuhSN7c6tNZCl0K3ioPSvYiDFCcH/wcHI+SR3BvywJRitxjfu195wYYYEnz2jPd853e/e865ggnRaDTmlFInJJ8CWPZ9PxwnlUkAY8w+yVdpXkSOtNYvMwOstc+TJAlFZOquyDnnykEQXIxCxjowxnwhuTksFpEDrfXrsYB6vZ5XSi14njcPoExyA0D69uGIAewCOFdKXSZJUisWi5EYY3ZIvgOgJvVj0jnJr9JsNq8B5B9bfKf/kwJ+AFj5H4CIfBdr7TPn3DGAxUdCDjudzlp/Cu12ezqO458kKxkhh1rrVRGJB2NMJ5HL5X6TfKiZt1rrGRG56S/ZvxujKJrt9XpXWRx0u93ZUqn06x7AGPOC5FkWgFKqUigU+tqBA2vtG+fcXhaAiLzVWn8bdbBF8tMQoCYiH0gmALYBLAzlPvq+/37UQfqBTkXkCYDPYRgeVKvVdH1B0mu1WuvOuS0AN865pSAIGmnuL4BAqYD60aJ1AAAAAElFTkSuQmCC"/>-->
                  <!--                      <span style="margin-left: 5px;" v-if="row.isHide===2">-->
                  <!--                        {{ $t('common.cds16') }}-->
                  <!--                      </span>-->
                  <!--                      <span style="margin-left: 5px;" v-else>-->
                  <!--                        {{ $t('common.cds15') }}-->
                  <!--                      </span>-->
                  <!--                    </template>-->
                  <!--                  </el-dropdown-item>-->
                  <el-dropdown-item @click="targetFileChange(row)">
                    <el-icon>
                      <Edit/>
                    </el-icon>
                    <span>{{ $t("common.rename") }}</span></el-dropdown-item>
                  <el-dropdown-item @click="sharedTargetFile(row,'1')">
                    <el-icon>
                      <UploadFilled/>
                    </el-icon>
                    <span>{{ $t("common.joint.with") }}</span></el-dropdown-item>
                  <el-dropdown-item @click="shareLink(row)">
                    <el-icon>
                      <Promotion/>
                    </el-icon>
                    <span>{{ $t("common.share") }}</span></el-dropdown-item>
                  <el-dropdown-item @click="moveTo(row,'1')">
                    <el-icon>
                      <Rank/>
                    </el-icon>
                    <span>{{ $t("common.move.to") }}</span></el-dropdown-item>
                  <el-dropdown-item @click="moveTo(row,'3')">
                    <el-icon>
                      <CopyDocument/>
                    </el-icon>
                    <span>{{ $t("common.copy.to") }}</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click="downloadTargetFile(row)">
                    <el-icon>
                      <Download/>
                    </el-icon>
                    <span>{{ $t("common.download") }}</span></el-dropdown-item>
                  <el-dropdown-item style="color: var(--el-color-danger)" @click="targetFileDelete(row,'2')">
                    <el-icon>
                      <Delete/>
                    </el-icon>
                    <span>{{ $t("common.delete") }}</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column v-if="type===2" prop="createName" width="160" :label="$t('common.cds13')"></el-table-column>
        <el-table-column v-if="type===4" width="120" prop="shareDay" :label="$t('common.joint.state')">
          <template #default="{row}">
            <el-button link type="info" v-if="row.shareDay!==0">
              {{ $t("displace.cloud.afterinvalidNumberDays", {num: row.shareDay}) }}
            </el-button>
            <el-button link v-else type="info" disabled>{{ $t("common.expired") }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="contentSize" sortable :label="$t('common.size')" width="120">
          <template #default="scope">
            <template v-if="scope.row.isFolder===2"></template>
            <template v-else>
              {{ formatSize(scope.row.fileSize) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column v-if="type===1||type===3||type===5" prop="date" sortable :label="$t('common.time.update')"
                         width="180"
                         show-overflow-tooltip>
          <template #default="scope">
            <template v-if="scope.row.updateTime!=null">{{ scope.row.updateTime }}</template>
            <template v-else>
              {{ scope.row.createTime }}
            </template>
          </template>
        </el-table-column>
        <el-table-column v-if="type===2" prop="createTime" sortable :label="$t('common.cds18')" width="180"
                         show-overflow-tooltip/>
        <el-table-column v-if="type===4" prop="createTime" sortable :label="$t('common.time.share')" width="160"
                         show-overflow-tooltip/>
        <el-table-column v-if="type===6" prop="deleteDate" sortable :label="$t('common.xcsj')" width="180"
                         show-overflow-tooltip>
          <template #default="{row}">
            <template v-if="row.updateTime">{{ row.updateTime }}</template>
            <template v-else>{{ row.createTime }}</template>
          </template>
        </el-table-column>
        <el-table-column v-if="type===4" fixed="right" :label="$t('common.cz')" :width="lang==='en'?220:180">
          <template #default="{row}">
            <el-button link type="primary" @click="cancelShare(row)">{{ $t("common.cancel.share") }}</el-button>
            <el-button link type="primary" @click="copyLink(row)">{{ $t("common.link.copy") }}</el-button>
          </template>
        </el-table-column>
        <template #empty>
          <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
        </template>
      </el-table>
      <template v-else-if="isSelect===1">
        <div class="top_select" v-if="total">
          <el-checkbox
              label="单页全选"
              :indeterminate="isIndeterminate"
              v-model="isSelectPage"
              @change="handleClickChangeIsSelectPage"/>
          <!--          <span style="font-size: 14px;"></span>-->
        </div>
        <div class="grid_box" ref="gridContainer">
          <div
              :class="['grid_item',item.isSelectCheck?'isSelectCheck_bg':'base_bg']"
              v-for="(item,index) in tableData"
              :key="item.id"
              @click="selectClickEventList(item)"
          >
            <div class="check_left_top_box" v-show="hoverId === item.id || item.isSelectCheck">
              <el-checkbox
                  :model-value="item.isSelectCheck"
                  @change="val => handleClickChangeFileItem(item, val, index)"
                  @click.stop
              />
            </div>
            <div class="top_area">
              <div v-if="item.isFolder===1" style="display: flex;align-items: center;flex-direction: column">
                <FileIcon style="margin: 10px !important;" :fileExtend="item?.fileExtend?.toLocaleLowerCase()"
                          :fileUrl="item?.fileExtendPath" :size="50"
                          :isAbbreviation="true"></FileIcon>
                <el-button v-if="type!==6 && imgFormat.includes(item?.fileExtend?.toLocaleLowerCase())" link
                           class="pointer"
                           style="margin-left: 10px;"
                           @click.stop="showTargetFile(item)"
                >
                <span
                    style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;width: 100%;max-width: 100px;line-height: 20px">
                  {{
                    item.fileName
                  }}
                </span>
                </el-button>
                <el-button v-else link class="pointer"
                           style="margin-left: 10px;line-height: 20px" @dblclick.stop="toShowTargetFile(item)">
               <span style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;width: 100%;max-width: 100px">
                  {{
                   item.fileName
                 }}
                </span>
                </el-button>
              </div>
              <div v-if="item.isFolder===2" style="display: flex;align-items:center;flex-direction: column;">
              <span style="display: block;height: 50px;margin: 15px" class="icon"><i aria-label="图标: folder"
                                                                                     class="anticon anticon-folder"
                                                                                     style="color: rgb(41, 182, 246); font-size: 50px;"><svg
                  viewBox="64 64 896 896" data-icon="folder" width="1em" height="1em" fill="currentColor"
                  aria-hidden="true" focusable="false" class=""><path
                  d="M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z"></path></svg></i></span>
                <el-button link type="primary" class="pointer"
                           style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;width: 100%;max-width: 100px;justify-content:center !important;margin-top: -10px;line-height: 20px"
                           @click.stop="enterDirectory(item)">
                  {{ item.fileName }}
                </el-button>
              </div>
            </div>
            <div>
              <template v-if="item.isFolder!==2">
                <img v-if="item.isHide===2" @click.stop="() => handleSettingStress(item,)"
                     class="pointer flags_f"
                     style="width: 14px;height: 14px"
                     src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAZ1JREFUOE+dk71LXEEUxc+Z997uGtC1sZD8A4ql1T5UDNq4EE38gKQTAzZJl04LNQnYCHYRCyX1ypLdLNFKUPzKH5BCLZZUESWEpIr6ZubKewmyK7v64pRzz/1x7rkzRJ0j+e5W7doNCFLGMJsa2S3XkrIeQBf9FRFOhHUSH92hveHYACllHmrDMsDE3yaxVktHcvTg8CakpoOg6C9A+LpSTMqqO7T/oiZAcv3pIPWnXRlpI9lhiVfh7DfEmsCSFfuVcI5dyyOO7JwwKPpvIZgCqOrlccv9InXB/yVg+h7NIPCbQcFfAzh6T8AHSi7TYBJOSSB9/wMhkHdOz59HW5BS5wNtUp8B9MaE5N2094yPtsJg/20615k2ieRPuStMQeAmmxqZ3biIHtk1YL27RV/aszgOXMdr4eOtH1WAoOj3QLgdBwCler3BnUh77cB86pq0VpbjAJTiS2dw9321g0LXNCDvKgBHpMwCyojYOYDtFbU33pO9meoMog+kNgkkKZxXze5qmHK0pdyYY7zv4yCmBbjQYgYann75FtauADgOlbK39b/7AAAAAElFTkSuQmCC"/>
                <img v-else class="pointer flags_f" style="width: 14px;height: 14px"
                     @click.stop="() => handleSettingStress(item,)"
                     src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAY5JREFUOE+dk7FLW1EUxr9zH7GtIJkcpOS+vClK/oeS4KRjcdBNWuhSN7c6tNZCl0K3ioPSvYiDFCcH/wcHI+SR3BvywJRitxjfu195wYYYEnz2jPd853e/e865ggnRaDTmlFInJJ8CWPZ9PxwnlUkAY8w+yVdpXkSOtNYvMwOstc+TJAlFZOquyDnnykEQXIxCxjowxnwhuTksFpEDrfXrsYB6vZ5XSi14njcPoExyA0D69uGIAewCOFdKXSZJUisWi5EYY3ZIvgOgJvVj0jnJr9JsNq8B5B9bfKf/kwJ+AFj5H4CIfBdr7TPn3DGAxUdCDjudzlp/Cu12ezqO458kKxkhh1rrVRGJB2NMJ5HL5X6TfKiZt1rrGRG56S/ZvxujKJrt9XpXWRx0u93ZUqn06x7AGPOC5FkWgFKqUigU+tqBA2vtG+fcXhaAiLzVWn8bdbBF8tMQoCYiH0gmALYBLAzlPvq+/37UQfqBTkXkCYDPYRgeVKvVdH1B0mu1WuvOuS0AN865pSAIGmnuL4BAqYD60aJ1AAAAAElFTkSuQmCC"/>
              </template>
              <div v-else class="pointer flags_f" style="height: 15px"></div>
            </div>
            <div style="position: absolute;right:6px;top: 0px;">
              <div class="tools" v-show="true">
                <el-dropdown v-if="type!==2&&type!==4&&type!==6" @visible-change="handleDropdownChange">
                  <el-icon style="margin: 0px 2px">
                    <MoreFilled/>
                  </el-icon>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <!--                      <el-dropdown-item v-if="type===1||type===3||type===5"-->
                      <!--                                        @click.stop="() => handleSettingStress(item)">-->
                      <!--                        <template v-if="item.isFolder!==2">-->
                      <!--                          <img v-if="item.isHide===2"-->
                      <!--                               class="pointer flags_f"-->
                      <!--                               src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAZ1JREFUOE+dk71LXEEUxc+Z997uGtC1sZD8A4ql1T5UDNq4EE38gKQTAzZJl04LNQnYCHYRCyX1ypLdLNFKUPzKH5BCLZZUESWEpIr6ZubKewmyK7v64pRzz/1x7rkzRJ0j+e5W7doNCFLGMJsa2S3XkrIeQBf9FRFOhHUSH92hveHYACllHmrDMsDE3yaxVktHcvTg8CakpoOg6C9A+LpSTMqqO7T/oiZAcv3pIPWnXRlpI9lhiVfh7DfEmsCSFfuVcI5dyyOO7JwwKPpvIZgCqOrlccv9InXB/yVg+h7NIPCbQcFfAzh6T8AHSi7TYBJOSSB9/wMhkHdOz59HW5BS5wNtUp8B9MaE5N2094yPtsJg/20615k2ieRPuStMQeAmmxqZ3biIHtk1YL27RV/aszgOXMdr4eOtH1WAoOj3QLgdBwCler3BnUh77cB86pq0VpbjAJTiS2dw9321g0LXNCDvKgBHpMwCyojYOYDtFbU33pO9meoMog+kNgkkKZxXze5qmHK0pdyYY7zv4yCmBbjQYgYann75FtauADgOlbK39b/7AAAAAElFTkSuQmCC"/>-->
                      <!--                          <img v-else class="pointer flags_f"-->
                      <!--                               src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAY5JREFUOE+dk7FLW1EUxr9zH7GtIJkcpOS+vClK/oeS4KRjcdBNWuhSN7c6tNZCl0K3ioPSvYiDFCcH/wcHI+SR3BvywJRitxjfu195wYYYEnz2jPd853e/e865ggnRaDTmlFInJJ8CWPZ9PxwnlUkAY8w+yVdpXkSOtNYvMwOstc+TJAlFZOquyDnnykEQXIxCxjowxnwhuTksFpEDrfXrsYB6vZ5XSi14njcPoExyA0D69uGIAewCOFdKXSZJUisWi5EYY3ZIvgOgJvVj0jnJr9JsNq8B5B9bfKf/kwJ+AFj5H4CIfBdr7TPn3DGAxUdCDjudzlp/Cu12ezqO458kKxkhh1rrVRGJB2NMJ5HL5X6TfKiZt1rrGRG56S/ZvxujKJrt9XpXWRx0u93ZUqn06x7AGPOC5FkWgFKqUigU+tqBA2vtG+fcXhaAiLzVWn8bdbBF8tMQoCYiH0gmALYBLAzlPvq+/37UQfqBTkXkCYDPYRgeVKvVdH1B0mu1WuvOuS0AN865pSAIGmnuL4BAqYD60aJ1AAAAAElFTkSuQmCC"/>-->
                      <!--                          <span style="margin-left: 5px;" v-if="item.isHide===2">-->
                      <!--                        {{ $t('common.cds16') }}-->
                      <!--                      </span>-->
                      <!--                          <span style="margin-left: 5px;" v-else>-->
                      <!--                        {{ $t('common.cds15') }}-->
                      <!--                      </span>-->
                      <!--                        </template>-->
                      <!--                      </el-dropdown-item>-->
                      <el-dropdown-item @click="targetFileChange(item)">
                        <el-icon>
                          <Edit/>
                        </el-icon>
                        <span>{{ $t("common.rename") }}</span></el-dropdown-item>
                      <el-dropdown-item @click="sharedTargetFile(item,'1')">
                        <el-icon>
                          <UploadFilled/>
                        </el-icon>
                        <span>{{ $t("common.joint.with") }}</span></el-dropdown-item>
                      <el-dropdown-item @click="shareLink(item)">
                        <el-icon>
                          <Promotion/>
                        </el-icon>
                        <span>{{ $t("common.share") }}</span></el-dropdown-item>
                      <el-dropdown-item @click="moveTo(item,'1')">
                        <el-icon>
                          <Rank/>
                        </el-icon>
                        <span>{{ $t("common.move.to") }}</span></el-dropdown-item>
                      <el-dropdown-item @click="moveTo(item,'3')">
                        <el-icon>
                          <CopyDocument/>
                        </el-icon>
                        <span>{{ $t("common.copy.to") }}</span>
                      </el-dropdown-item>
                      <el-dropdown-item @click="downloadTargetFile(item)">
                        <el-icon>
                          <Download/>
                        </el-icon>
                        <span>{{ $t("common.download") }}</span></el-dropdown-item>
                      <el-dropdown-item style="color: var(--el-color-danger)" @click="targetFileDelete(item,'2')">
                        <el-icon>
                          <Delete/>
                        </el-icon>
                        <span>{{ $t("common.delete") }}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="box_file_text" v-if="type!==6">
      <div style="padding: 20px;height: 100%">
        <div class="titles" style="margin-bottom: 12px" v-if="activeItem.length===1">
          {{
            $t('common.file.info')
          }}
        </div>
        <div class="sp_des">{{
            activeItem[0] && activeItem[0].fileExtend
                ? !suportFile.includes(activeItem[0].fileExtend?.toLowerCase())
                    ? ''
                    : imgFormat.includes(activeItem[0].fileExtend?.toLowerCase())
                        ? $t('file.click.show')
                        : $t('file.double.click.show')
                : ''
          }}
        </div>
        <div class="titles" style="margin-bottom: 12px" v-if="activeItem.length>1">
          {{ $t("displace.file.select.total", {number: activeItem.length}) }}
        </div>
        <div class="file_boxs" style="height: 100%;" v-if="activeItem.length===0">
          <div style="display: flex;justify-content: center;flex-direction: column;align-items: center">
            <div style="height: 54px;"><span>
              <i
                  aria-label="图标: folder"
                  class="anticon anticon-folder"
                  style="color: rgb(41, 182, 246); font-size: 60px;"><svg
                  viewBox="64 64 896 896" data-icon="folder" width="1em" height="1em" fill="currentColor"
                  aria-hidden="true" focusable="false" class=""><path
                  d="M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z"></path></svg></i></span>
            </div>
            <div class="f12" style="color: rgb(135, 140, 156); margin-top: 10px;">
              {{ $t("common.select.file.details") }}
            </div>
          </div>
        </div>
        <template v-else-if="activeItem.length===1">
          <!--          文件-->
          <!--        展示普通的文件资源-->
          <div v-if="activeItem[0].isFolder===1"
               style="width: 100%;display: flex;flex-direction: column;justify-content: center">
            <div class="file_details" style="display: flex;justify-content: center;align-items: center">
              <!--              <el-image v-if="imgFormat.includes(activeItem[0].isFolder)" style="width: 100%; height: 160px" :src="activeItem[0].fileExtendPath" fit="contain"/>-->
              <FileIcon :fileExtend="activeItem[0]?.fileExtend?.toLowerCase()" :fileUrl="activeItem[0].fileExtendPath"
                        :size="60"></FileIcon>
            </div>
            <div class="image_titles">{{ activeItem[0]?.fileName }}</div>
            <div class="detail-msg flex1 oh fx-d-c">
              <div>{{ $t("common.file.format") }}：{{ activeItem[0]?.fileExtend }}</div>
              <div>{{ $t("common.time.create") }}：{{ activeItem[0]?.createTime }}</div>
              <div>{{ $t("common.lastupdate") }}：{{
                  activeItem[0]?.updateTime ? activeItem[0]?.updateTime : activeItem[0]?.createTime
                }}
              </div>
              <div v-if="activeItem[0].shareName">{{
                  $t('common.share.name')
                }}：{{ activeItem[0].shareName }}
              </div>
              <div v-if="activeItem[0].createName">
                <template v-if="type===2">
                  {{ $t('common.share.from') }}：{{ activeItem[0].createName }}
                </template>
                <!--                <template v-else-if="type===3">-->
                <!--                  {{ $t('common.share.from') }}：{{ activeItem[0].createName }}-->
                <!--                </template>-->
              </div>
            </div>
          </div>
          <!--          文件夹-->
          <div v-else style="width: 100%;display: flex;flex-direction: column;justify-content: center">
            <div style="display: flex;justify-content: flex-start;justify-items: center">
              <span style="display: inline-block;height: 24px" class="icon"><i aria-label="图标: folder"
                                                                               class="anticon anticon-folder"
                                                                               style="color: rgb(41, 182, 246); font-size: 24px;"><svg
                  viewBox="64 64 896 896" data-icon="folder" width="1em" height="1em" fill="currentColor"
                  aria-hidden="true" focusable="false" class=""><path
                  d="M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z"></path></svg></i></span>
              <span link type="primary" class="pointer" style="margin-left: 6px;">
                {{ activeItem[0].fileName }}
              </span>
            </div>
            <div class="file_details_long">
              <div style="padding: 20px;">
                <div v-if="showLoading" v-loading="showLoading" style="margin-top: 10%"></div>
                <div v-else v-for="row in dirFileList">
                  <div v-if="row?.isFolder===1" style="display: flex;align-items: center;margin-bottom: 10px">
                    <FileIcon :fileExtend="row?.fileExtend?.toLocaleLowerCase()"
                              :fileUrl="row?.fileExtendPath" :size="25"
                              :isAbbreviation="true"></FileIcon>
                    <el-button link class="pointer previewfile"
                    >
                      <span
                          style="display: inline-block;
                          text-align: left;
                          width: 200px;
                          line-height: 20px;
                          overflow: hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;"
                      >
                        {{
                          row.fileName
                        }}
                      </span>
                    </el-button>
                  </div>
                  <div v-if="row?.isFolder===2" style="display: flex;align-items: center;margin-bottom: 10px">
              <span style="display: block;height: 24px" class="icon"><i aria-label="图标: folder"
                                                                        class="anticon anticon-folder"
                                                                        style="color: rgb(41, 182, 246); font-size: 24px;"><svg
                  viewBox="64 64 896 896" data-icon="folder" width="1em" height="1em" fill="currentColor"
                  aria-hidden="true" focusable="false" class=""><path
                  d="M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z"></path></svg></i></span>
                    <el-button link type="primary" class="pointer previewfile"
                               style="margin-left: 10px"
                    >
                       <span
                           style="display: inline-block;
                          text-align: left;
                          width: 200px;
                          line-height: 20px;
                          overflow: hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;"
                       >
                        {{
                           row.fileName
                         }}
                      </span>
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="select_option oh"
               style="background: rgb(245, 245, 245); border-radius: 8px; height: 160px;">
            <span
                style="vertical-align: middle;"><i
                aria-label="图标: folder" class="anticon anticon-folder"
                style="color: rgb(41, 182, 246); font-size: 50px;">
              <svg viewBox="64 64 896 896" data-icon="folder"
                   width="1em" height="1em" fill="currentColor"
                   aria-hidden="true" focusable="false" class=""><path
                  d="M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z"></path></svg></i></span>
          </div>
        </template>
      </div>
    </div>
  </div>
  <div id="pages_com" :style="{marginRight:route.path==='/cloud/recycle'?'0px':'320px'}">
    <el-pagination
        size="small"
        v-model:current-page="current"
        v-model:page-size="size"
        background
        layout="total, prev, pager, next"
        v-if="total"
        :total="total"
        @current-change="handleCurrentChange"
    />
  </div>
  <!--  弹出框 上传列表-->
  <UploadBox ref="uploadRefs" :fileList="fileList" @removeList="handleClickRemoveListReset"></UploadBox>
  <EmlPreviewDialog v-model="emlPreviewVisible" :attachment="emlPreviewAttachment" />
  <!--  新建文件夹-->
  <CreateDir v-if="visitable" v-model="visitable" @close="close" :isHeadLine="false"
             @getFileList="resetGetFileList"></CreateDir>
  <!--创建分享链接前的询问-->
  <BeforeCreateShareLink v-if="visitableLinkBefore" v-model="visitableLinkBefore" @close="closeLinkBefore"
                         :isHeadLine="false" :activeItem="activeItem"
                         @showLink="handleClickShowLink"></BeforeCreateShareLink>
  <!--  创建分享链接-->
  <CreateShareLink v-if="visitableLink" v-model="visitableLink" @close="closeLink"
                   :isHeadLine="false" :activeItem="activeItem" :shareDay="shareDay"
                   :fileName="fileName"></CreateShareLink>
  <!--  移动对话框-->
  <MoveTargetFile v-if="moveTargetFileVisitable" v-model="moveTargetFileVisitable"
                  @close="closeMoveTarget" :is-head-line="false" :type="type" :activeItem="activeItem"
                  :list="resetGetFileList" :numberFlag="numberFlag"></MoveTargetFile>
  <!--  删除对话框-->
  <Dialog
      v-model="deleteVisitable"
      width="450"
      :dialogVisible="deleteVisitable"
      :isHeadLine="false"
      :title="$t('tips')"
      @update:dialogVisible="(val) => (deleteVisitable = val)"
  >
    <template #content>
      <div class="cont" style="margin: 0px 8px;">
        <!--        <span><el-icon style="color:#efb041;font-size: 20px;margin-right: 10px;"><QuestionFilled/></el-icon></span>-->
        <span class="text" v-if="flags===2">{{ $t("common.delete.select.file") }}</span>
        <span class="text" v-else-if="flags===3">{{ $t("common.true.delete.select.file") }}</span>
        <span class="text" v-else-if="flags===1">{{ $t("common.hf.select.file") }}</span>
        <span class="text" v-else-if="flags===4">{{ $t("common.clean.recycle") }}</span>
      </div>
    </template>
    <template #footer>
      <div class="setting_left">
        <el-button size="small" @click="deleteVisitable = false">{{ $t('common.sss16') }}</el-button>
        <el-button size="small" type="primary" :loading="deleteLoading" @click="deleteTarget">{{
            $t('common.confirm')
          }}
        </el-button>
      </div>
    </template>
  </Dialog>
  <!--  文件重命名-->
  <ChangeFile v-if="changeVisitable" v-model="changeVisitable" @close="closeChangeVisitable"
              :targetItem="changTargetItem"></ChangeFile>
  <!--  共享给我-->
  <SharedMe v-if="visitableShared" v-model="visitableShared" @close="closeShared" :isHeadLine="false"
            :activeItem="activeItem" @getList="resetGetFileList" :numberFlags="numberFlags"></SharedMe>
  <!--  云空间不足 警告-->
  <ToBuyFileArea v-if="toBuyDialogVisible" v-model="toBuyDialogVisible"
                 @close="toBuyDialogVisibleClose"></ToBuyFileArea>

  <!--  <show-video v-if="visitableVideo" v-model="visitableVideo" @close="closeVideo" :isHeadLine="false"-->
  <!--  ></show-video>-->
</template>

<script setup>
import {computed, nextTick, onBeforeUnmount, onMounted, onUnmounted, reactive, ref, watch, watchEffect} from 'vue'
import {
  UploadFilled,
  FolderAdd,
  Download,
  DeleteFilled,
  Share,
  Promotion,
  Rank,
  CopyDocument,
  StarFilled, Tickets, Setting, DocumentDelete, RefreshLeft, Delete, CircleClose, MoreFilled, Edit
} from "@element-plus/icons-vue";
import {ElMessage, ElTable} from "element-plus";
import {useRoute, useRouter} from "vue-router";
import {getApi1, getTargetFile} from "@/api/fileupload";
import "viewerjs/dist/viewer.css";
import {api as viewerApi} from 'v-viewer';
import {getToken} from "@/utils/auth";
import UploadBox from "@/views/Cloud/Components/UploadBox.vue";
import CreateDir from "@/views/Cloud/Components/CreateDir.vue";
import CreateShareLink from "@/views/Cloud/Components/CreateShareLink.vue";
import {debouncePlus, throttle} from "@/utils/mylodash";
import Dialog from "@/components/Dialog.vue";
import {useStore} from "vuex";
import MoveTargetFile from "@/views/Cloud/Components/MoveTargetFile.vue";
import {
  audioFormat,
  downloadFile,
  excelFormat,
  formatSize,
  imgFormat,
  pdfFormat, pptFormat, shouldIgnoreFileOrFolder, textFormat, uploadFile,
  videoFormat,
  wordFormat, zipFormat, isEmlFile
} from "@/utils/file";
import ChangeFile from "@/views/Cloud/Components/ChangeFile.vue";
import SharedMe from "@/views/Cloud/Components/SharedMe.vue";
import useClipboard from "vue-clipboard3";
import {emptyUrl, UPLOAD_FILE_MAX_SIZE} from "@/utils/statusParams";
import ToBuyFileArea from "@/components/DiaPops/ToBuyFileArea.vue";
import {i18n} from "@/lang";
import FileIcon from "@/components/File/FileIcon.vue";
import EmlPreviewDialog from "@/components/EmlPreviewDialog.vue";
import ShowVideo from "@/components/ShowTargetFile/showVideo.vue";
import axios from "axios";
import {downZip} from "@/api";
import {downFileMkdirZip} from "@/api/cloud";
import BeforeCreateShareLink from "@/views/Cloud/Components/BeforeCreateShareLink.vue";
import dayjs from "dayjs";

const TIME_DELAY = 300;
const route = useRoute();
const router = useRouter();
const store = useStore();
const {toClipboard} = useClipboard();
const lang = computed(() => store.state.system.langLocal)
const searchFile = ref('')

// 记录上传文件的路径
let folderMap = new Map()

const switchingLoading = ref(false)

// 选择布局方式
const isSelect = computed(() => store.state.cloud.isSelect)
const handleClickChange = async (type) => {
  if (isSelect.value === type) return
  switchingLoading.value = true
  await store.commit("cloud/setIsSelect", type)
  if (isSelect.value === 1) {
    toParentDivEvent()
  }

  await nextTick()
  await new Promise(resolve => requestAnimationFrame(() => resolve()))
  switchingLoading.value = false
}

const BREADCRUMB_ACTIVE_KEY = 'pathArray'
const BREADCRUMB_TEMPLATE_KEY = 'pathTemplateDb'

const createRootBreadcrumb = () => ({
  path: '0',
  text: i18n.global.t("common.file.all"),
  tag: '0'
})

const getRootBreadcrumbList = () => [createRootBreadcrumb()]

const getRouteFolderId = () => route.query.id ? String(route.query.id) : ''
const getRouteFolderPath = () => route.query.path ? String(route.query.path) : ''

const isValidBreadcrumbItem = (item) => item && item.text !== undefined && item.tag !== undefined

const safeReadBreadcrumbStorage = (key) => {
  const rawValue = sessionStorage.getItem(key)
  if (!rawValue) return null
  try {
    const parsedValue = JSON.parse(rawValue)
    return Array.isArray(parsedValue) ? parsedValue.filter(isValidBreadcrumbItem) : null
  } catch (e) {
    console.error(`解析 ${key} 失败:`, e)
    return null
  }
}

const normalizeBreadcrumbList = (list = []) => {
  const breadcrumbList = Array.isArray(list) ? list.filter(isValidBreadcrumbItem) : []
  const rootItem = createRootBreadcrumb()
  const normalizedList = []
  const firstItem = breadcrumbList[0]

  if (!firstItem || String(firstItem.tag) !== '0') {
    normalizedList.push(rootItem)
  }

  breadcrumbList.forEach((item) => {
    const tag = String(item.tag)
    if (normalizedList.some(breadcrumb => breadcrumb.tag === tag)) return
    normalizedList.push({
      path: '',
      text: item.text,
      tag
    })
  })

  if (normalizedList.length === 0) {
    normalizedList.push(rootItem)
  }

  return normalizedList.map((item, index) => ({
    ...item,
    path: normalizedList.slice(0, index + 1).map(breadcrumb => breadcrumb.tag).join(',')
  }))
}

const writeBreadcrumbTemplate = (activeBreadcrumbList) => {
  const savedTemplateList = safeReadBreadcrumbStorage(BREADCRUMB_TEMPLATE_KEY) || []
  const templateMap = new Map()

  ;[createRootBreadcrumb(), ...savedTemplateList].forEach((item) => {
    const tag = String(item.tag)
    if (!templateMap.has(tag)) {
      templateMap.set(tag, {
        path: item.path || '',
        text: item.text,
        tag
      })
    }
  })

  activeBreadcrumbList.forEach((item) => {
    templateMap.set(item.tag, {
      path: item.path,
      text: item.text,
      tag: item.tag
    })
  })

  sessionStorage.setItem(BREADCRUMB_TEMPLATE_KEY, JSON.stringify(Array.from(templateMap.values())))
}

const syncBreadcrumbState = (list) => {
  const normalizedList = normalizeBreadcrumbList(list)
  pathArray.value = normalizedList
  sessionStorage.setItem(BREADCRUMB_ACTIVE_KEY, JSON.stringify(normalizedList))
  writeBreadcrumbTemplate(normalizedList)
  return normalizedList
}

const rebuildBreadcrumbByRoutePath = (routePath) => {
  if (!routePath) return null

  const templateList = safeReadBreadcrumbStorage(BREADCRUMB_TEMPLATE_KEY)
  if (!templateList?.length) return null

  const templateMap = new Map(
      templateList.map((item) => [String(item.tag), item])
  )
  const routePathIds = routePath.split(',').filter(Boolean)
  const rebuiltList = []

  for (const pathId of routePathIds) {
    if (pathId === '0') {
      rebuiltList.push(createRootBreadcrumb())
      continue
    }

    const matchedItem = templateMap.get(String(pathId))
    if (!matchedItem) {
      return null
    }

    rebuiltList.push({
      text: matchedItem.text,
      tag: String(matchedItem.tag)
    })
  }

  return normalizeBreadcrumbList(rebuiltList)
}

/**
 * 面包屑仍以 route.query 为准，sessionStorage 只负责恢复展示信息。
 */
const checkRouter = () => {
  const routeFolderId = getRouteFolderId()
  const routeFolderPath = getRouteFolderPath()

  if (!routeFolderId) {
    syncBreadcrumbState(getRootBreadcrumbList())
    console.log('重置为根目录面包屑')
    return
  }

  const savedActiveBreadcrumbList = safeReadBreadcrumbStorage(BREADCRUMB_ACTIVE_KEY)
  const normalizedActiveBreadcrumbList = savedActiveBreadcrumbList
      ? normalizeBreadcrumbList(savedActiveBreadcrumbList)
      : null
  const lastActiveBreadcrumb = normalizedActiveBreadcrumbList?.[normalizedActiveBreadcrumbList.length - 1]
  const isActiveBreadcrumbMatched = lastActiveBreadcrumb
      && lastActiveBreadcrumb.tag === routeFolderId
      && (!routeFolderPath || lastActiveBreadcrumb.path === routeFolderPath)

  if (isActiveBreadcrumbMatched) {
    pathArray.value = normalizedActiveBreadcrumbList
    console.log('从 sessionStorage 恢复面包屑:', pathArray.value)
    return
  }

  const rebuiltBreadcrumbList = rebuildBreadcrumbByRoutePath(routeFolderPath)
  if (rebuiltBreadcrumbList?.length) {
    syncBreadcrumbState(rebuiltBreadcrumbList)
    console.log('根据 route.query.path 重建面包屑:', pathArray.value)
    return
  }

  syncBreadcrumbState(getRootBreadcrumbList())
  console.log('重置为默认根目录面包屑')
}


/**
 * 收藏
 * @returns {Promise<void>}
 */
const collectTo = debouncePlus(async (num) => {
  if (activeItem.value.length === 0) {
    ElMessage.warning(i18n.global.t("sys.tip.select.file"));
    return
  } else if (activeItem.value.filter(item => item.isFolder === 2).length >= 1) {
    ElMessage.warning(i18n.global.t("common.file.dir"));
    return
  } else {
    const idList = activeItem.value.map(_ => _.id)
    await store.dispatch("cloud/hideFileApis", {idList, isHide: num * 1})
    if (type === 5) {
      tableData.value = tableData.value.filter(item => !idList.includes(item.id))
    } else {
      tableData.value = findTargetItemIsHide(tableData.value, idList)
    }
    await getFileList()
  }
}, TIME_DELAY)

const handleSettingStress = async (row, num) => {
  const idList = [row.id];
  console.log('ddd', row.isHide, tableData.value, idList)
  await store.dispatch("cloud/hideFileApis", {idList, isHide: row.isHide === 2 ? 1 : 2})
  if (type === 5) {
    const startIndex = tableData.value.findIndex(item => item.id === row.id)
    tableData.value.splice(startIndex, 1)
  } else {
    tableData.value = findTargetItem(tableData.value, idList)
  }
}

/**
 * 一键收藏
 * @param arr1
 * @param arr2
 */
const findTargetItemIsHide = (arr1, arr2) => {
  arr1.forEach(obj1 => {
    if (arr2.includes(obj1.id)) {
      obj1.isHide = 2;
    }
  });
}

/**
 * 前端 点击收藏 再次点击取消收藏
 */
const findTargetItem = (arr1, arr2) => {
  return arr1.map(obj1 => {
    if (arr2.includes(obj1.id)) {
      obj1.isHide = obj1.isHide === 2 ? 1 : 2;
    }
  });
}


// 文件移动
const moveTargetFileVisitable = ref(false);
const closeMoveTarget = () => {
  moveTargetFileVisitable.value = false
}
const numberFlag = ref('1')
const moveTo = debouncePlus((row, num) => {
  if (row.id) {
    activeItem.value = [];
    activeItem.value = [row]
  }
  console.log('fff', row, num, activeItem.value)
  if (activeItem.value.length === 0) {
    ElMessage.warning(i18n.global.t("sys.tip.select.file"));
    return
  } else {
    numberFlag.value = num
    // resetCurrentAbout()
    moveTargetFileVisitable.value = true;
  }
}, TIME_DELAY)


// 新建文件夹
const visitable = ref(false)
const addNewDir = () => {
  visitable.value = true;
}
const close = async () => {
  visitable.value = false

}

const resetGetFileList = async () => {
  await resetCurrentAbout()
  await getFileList();
}


// 下载文件
const downloadLoading = ref(false)
const downloadTargetFile = debouncePlus(async (row) => {
  if (row.id) {
    activeItem.value = []
    activeItem.value = [row]
  }
  if (activeItem.value.length === 0) {
    ElMessage.warning(i18n.global.t("sys.tip.select.file"));
    return
  } else if (activeItem.value.filter(_ => _.isFolder === 2).length === 1 && activeItem.value.filter(_ => _.isFolder === 1).length <= 0) {
    // ElMessage.warning(i18n.global.t("common.file.dir.download"))
    // 单个文件夹打包下载
    console.log('1')
    console.log(activeItem.value, 'activeItem.value')
    const {id} = activeItem.value[0]
    downloadLoading.value = true
    await downFileMkdirZip({fileId: [id]}, {
      responseType: 'blob'
    }).then(res => {
      downloadLoading.value = false
      const blob = new Blob([res], {type: 'application/zip;charset=UTF-8'}); // 使用 ZIP 文件的 MIME 类型
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = URL.createObjectURL(blob);
      var timestamp = Date.now();
      link.setAttribute('download', 'attachment_' + timestamp + '.zip');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href); // 清理创建的URL对象
    }).catch(error => {
      downloadLoading.value = false
      console.error('Error downloading file:', error);
    });
  } else if (activeItem.value.length === 1) {
    console.log('2')
    downloadLoading.value = true
    const safeUrl = activeItem.value[0].fileExtendPath.replace(/^http:\/\//i, "https://");
    fetch(safeUrl)
        .then(res => res.blob())
        .then(blob => {
          downloadLoading.value = false;
          downloadFile(blob, activeItem.value[0].fileName);
        })
        .catch(error => {
          downloadLoading.value = false;
          ElMessage.error('下载失败');
        });
  } else if (activeItem.value.length > 1) {
    console.log('3')
    const fileId = activeItem.value.map(item => item.id)
    //   多文件打包下载
    downloadLoading.value = true
    await downFileMkdirZip({fileId: fileId}, {
      responseType: 'blob'
    }).then(res => {
      downloadLoading.value = false
      const blob = new Blob([res], {type: 'application/zip;charset=UTF-8'}); // 使用 ZIP 文件的 MIME 类型
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = URL.createObjectURL(blob);
      var timestamp = Date.now();
      link.setAttribute('download', 'attachment_' + timestamp + '.zip');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href); // 清理创建的URL对象
    }).catch(error => {
      downloadLoading.value = false
      console.error('Error downloading file:', error);
    });
  }
}, TIME_DELAY)

// 删除文件
const deleteVisitable = ref(false)
const flags = ref(0);
const deleteTargetFile = debouncePlus((val) => {
  flags.value = val * 1;
  if (flags.value === 4) {
    deleteVisitable.value = true;
  } else {
    if (activeItem.value.length === 0) {
      ElMessage.warning(i18n.global.t('sys.tip.select.file'))
      return
    } else {
      deleteVisitable.value = true;
    }
  }
}, TIME_DELAY)
const deleteLoading = ref(false);
const deleteTarget = debouncePlus(async () => {
  if (flags.value === 4) {
    deleteLoading.value = true
    await store.dispatch("cloud/clearFileApis")
    deleteVisitable.value = false;
    deleteLoading.value = false;
  } else {
    // alert("删除选中的文件")
    const idList = activeItem.value.map(_ => _.id)
    const payload = {
      idList,
      type: flags.value,
    }
    deleteLoading.value = true
    if (targetDeleteList.value !== null) {
      await store.dispatch('cloud/deleteFileApis', {type: 2, idList: [targetDeleteList.value.id]})
    } else {
      await store.dispatch('cloud/deleteFileApis', payload)
    }
    deleteLoading.value = false;
    deleteVisitable.value = false;
  }
  await resetCurrentAbout()
  await getFileList()
}, TIME_DELAY);


/**
 * 处理完操作需要重新判断页数和 重置
 */
const resetCurrentAbout = async () => {
  await store.commit("cloud/changeCurrent", false)
  if (current.value * size.value >= total.value) {
    if (current.value)
      current.value = 1;
  }
  // 重置选中的状态
  await store.commit("cloud/setMultipleSelection", [])
  if (multipleTableRef.value) {
    multipleTableRef.value.clearSelection()
  }
}

// 共享文件
const visitableShared = ref(false);
const closeShared = () => {
  visitableShared.value = false;
}
const numberFlags = ref('1')
const sharedTargetFile = debouncePlus((row, num) => {
  if (row.id) {
    console.log(row, 'row')
    activeItem.value = [];
    activeItem.value = [row]
  }
  if (activeItem.value.length === 0) {
    ElMessage.warning(i18n.global.t("sys.tip.select.file"));
  }
      // else if (activeItem.value.filter(item => item.isFolder === 2).length >= 1) {
      //   // ElMessage.warning(i18n.global.t("common.cds17"))
      //   //   共享文件夹
      //
      //
  // }
  else {
    console.log(activeItem.value, 'a')
    numberFlags.value = num;
    if (num === '1') {
      visitableShared.value = true;
    } else {
      visitableShared.value = true;
    }
  }
}, TIME_DELAY)


// 创建分享链接
const visitableLink = ref(false);
const closeLink = () => {
  visitableLink.value = false;
  if (multipleTableRef.value) {
    multipleTableRef.value.clearSelection()
  }
}
const visitableLinkBefore = ref(false)
const closeLinkBefore = () => {
  visitableLinkBefore.value = false;
}

// 分享文件
const shareLink = debouncePlus((row) => {
  if (row.id) {
    activeItem.value = [];
    activeItem.value = [row]
  }
  if (activeItem.value.length === 0) {
    ElMessage.warning(i18n.global.t("sys.tip.select.file"))
    return
  } else {
    // visitableLink.value = true;
    visitableLinkBefore.value = true
  }
}, TIME_DELAY)

const action = ref(`${process.env.VUE_APP_BASE_API}/sys/oss/qiniu/upload`);
const token = getToken();
const multipartFiles = ref([]);

// 这里是通过文件列表接口进行展示的
const fileList = ref([])
const selectFileList = ref([])
// 文件空间信息
const spaceSize = computed(() => store.state.cloud.spaceSize)

const toBuyDialogVisible = ref(false)

const toBuyDialogVisibleClose = () => {
  toBuyDialogVisible.value = false;
}


// 标记是否允许 文件夹上传
const isAllowUploadFolder = ref(false)

// 工具函数：检查文件类型
function isFileTypeAllowed(fileName) {
  const FileExt = fileName.replace(/.+\./, "").toLowerCase();
  const forbidden = ['exe', 'iso'];
  return !forbidden.includes(FileExt);
}

// 工具函数：检查空间是否足够
function hasEnoughSpace(fileSize) {
  const free = spaceSize.value?.freeLocation || 0;
  console.log(fileSize, free, 'dddddddsssss')
  return fileSize <= free;
}

const getUploadTargetFile = (file) => file?.raw || file;

const getUploadLimitMessage = (fileName = '') => {
  const sizeText = formatSize(UPLOAD_FILE_MAX_SIZE);
  const hasFileName = Boolean(fileName);
  const isZh = String(lang.value || '').toLowerCase().includes('zh');

  if (isZh) {
    return hasFileName
        ? `文件"${fileName}"超过服务器上传限制，单个文件不能超过 ${sizeText}`
        : `文件超过服务器上传限制，单个文件不能超过 ${sizeText}`;
  }

  return hasFileName
      ? `File "${fileName}" exceeds the server upload limit. Each file must be smaller than ${sizeText}`
      : `File exceeds the server upload limit. Each file must be smaller than ${sizeText}`;
};

function validateUploadFile(file, {checkType = true, checkSize = true, checkSpace = true, notify = true} = {}) {
  const targetFile = getUploadTargetFile(file);
  if (!targetFile) return false;

  if (checkType && !isFileTypeAllowed(targetFile.name)) {
    if (notify) {
      ElMessage.warning(i18n.global.t('send.all.upload.ex'));
    }
    return false;
  }

  if (checkSize && targetFile.size > UPLOAD_FILE_MAX_SIZE) {
    if (notify) {
      ElMessage.warning(getUploadLimitMessage(targetFile.name));
    }
    return false;
  }

  if (checkSpace && !hasEnoughSpace(targetFile.size)) {
    toBuyDialogVisible.value = true;
    return false;
  }

  return true;
}

function filterValidUploadFiles(files, options = {}) {
  return files.filter(file => validateUploadFile(file, options));
}

// 文件上传前校验逻辑
const beforeUpload = async (file) => {
  if (targetMode.value === 'folder') {
    if (!validateUploadFile(file, {checkSpace: false})) {
      isAllowUploadFolder.value = false;
      return false;
    }

    // 上传文件夹
    if (!hasEnoughSpace(file.size)) {
      isAllowUploadFolder.value = false;
      toBuyDialogVisible.value = true;
      return false;
    } else {
      // 允许上传
      isAllowUploadFolder.value = true;
      // await handleClickUploadFolder(file);
      return false; // 阻止自动上传
    }
  } else {
    // 普通文件
    if (!validateUploadFile(file)) {
      return false;
    }
    selectFileList.value.push(file);
    return true;
  }
};

function handleUploadError(error) {
  try {
    const status = error?.response?.status || error?.status;
    const rawMsg = String(error?.message || error || '');
    const isFailToPost = /fail to post/i.test(rawMsg) && rawMsg.includes('/sys/oss/qiniu/upload');
    if (status === 413 || isFailToPost) {
      ElMessage.error('上传失败：文件过大，请压缩后重试或更换更小的文件。');
      return;
    }
  } catch (e) {
  }
  const msg = typeof error === 'string'
      ? error
      : (error?.response?.data?.message || error?.data?.message || error?.message || error?.response?.statusText || '上传失败，请稍后重试');
  ElMessage.error(String(msg || '上传失败，请稍后重试'))
}

const uploadPromises = ref([])
const numbers = ref(1);
const timer = ref(null)

const uploadTimeout = ref(null);
const tempFileBuffer = ref([])
const handleChange = async (files) => {
  const newFiles = Array.isArray(files) ? files : [files];
  console.log(newFiles, 'newFiles');
  const validFiles = filterValidUploadFiles(newFiles, {
    checkSpace: false,
    notify: false
  });

  if (!validFiles.length) {
    return;
  }

  tempFileBuffer.value.push(...validFiles); // ✅ 缓存原始 File 对象

  if (targetMode.value === 'folder') {
    // 清空文件列表
    if (uploadTimeout.value) clearTimeout(uploadTimeout.value);

    uploadTimeout.value = setTimeout(async () => {
      const totalSize = tempFileBuffer.value.reduce((sum, f) => sum + getUploadTargetFile(f).size, 0);
      console.log(hasEnoughSpace(totalSize), totalSize, 'totalSize');

      if (!hasEnoughSpace(totalSize)) {
        isAllowUploadFolder.value = false;
        toBuyDialogVisible.value = true;
        return;
      }

      try {
        uploadRefs.value.enterList();
        // ✅ 传入原始 File 列表（不是 fileList.value）
        await handleClickUploadFolder(tempFileBuffer.value);
      } catch (e) {
        console.log(e, 'upload error');
      } finally {
        folderMap = new Map();
        await getFileList();
        tempFileBuffer.value = []; // ✅ 清空临时缓存
      }
    }, 500);
  } else {
    // 单文件上传逻辑
    // 这里使用el-upload 的自动上传功能
  }
};
const handleClickUploadFolder = async (fileListArray) => {
  if (!isAllowUploadFolder.value) return;

  // 过滤掉隐藏文件或没有类型的文件
  const filteredFiles = Array.from(fileListArray).filter(file => file.raw.type !== "");
  console.log(filteredFiles, 'filteredFiles');

  // 初始化 fileList，展示进度
  for (const file of filteredFiles) {
    fileList.value.push({
      uid: file.raw.uid,
      name: file.raw.name, // 使用纯文件名
      raw: file.raw, // 保持 File 对象
      percentage: 0,
      status: 'ready',
      isMouseEnter: false,
    });
  }

  // 1. 收集所有文件夹路径
  const allPaths = new Set();
  for (const file of filteredFiles) {
    const folders = file.raw.webkitRelativePath.split('/').slice(0, -1);
    let currentPath = '';
    for (const part of folders) {
      currentPath = currentPath ? `${currentPath}/${part}` : part;
      allPaths.add(currentPath);
    }
  }

  // 2. 路径排序（父目录先）
  const sortedPaths = Array.from(allPaths).sort((a, b) => a.split('/').length - b.split('/').length);
  console.log(sortedPaths, 'sortedPaths');

  // 3. 创建所有文件夹
  for (const path of sortedPaths) {
    if (folderMap.has(path)) continue;

    const parts = path.split('/');
    const folderName = parts[parts.length - 1];
    const parentPath = parts.length > 1 ? parts.slice(0, -1).join('/') : null;

    const parentId = parentPath
        ? folderMap.get(parentPath) || '0'
        : currentParentId.value; // 使用捕获的 parentId

    const params = {
      isFolder: 2,
      filePath: parentId,
      parentId,
      createTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      fileName: folderName,
      fileArea: route.query.path || '0',
    };

    try {
      const res = await store.dispatch('cloud/addFile', params);
      folderMap.set(path, res.result);
      console.log(`创建文件夹成功: ${path} -> ID: ${res.result}`);
    } catch (e) {
      console.error(`创建文件夹失败: ${path}`, e);
    }
  }

  // 4. 上传文件并更新 fileList
  for (const file of filteredFiles) {
    try {
      const folderPath = file.raw.webkitRelativePath.split('/').slice(0, -1).join('/');
      const parentId = folderPath ? (folderMap.get(folderPath) || currentParentId.value) : currentParentId.value; // 使用捕获的 parentId

      const result = await uploadFile(file.raw, (percent) => {
        const idx = fileList.value.findIndex(f => f.uid === file.raw.uid);
        if (idx !== -1) fileList.value[idx].percentage = percent;
      });

      const {fileName, size, url, response} = result;

      const idx = fileList.value.findIndex(f => f.uid === file.raw.uid);
      if (idx !== -1) {
        fileList.value[idx] = {
          ...fileList.value[idx],
          response,
          percentage: 100,
          status: 'success',
          url,
          nameSp: file.raw.name, // 展示用名称
        };
      }

      const params = {
        fileName: file.raw.name, // 使用纯文件名
        parentId,
        filePath: parentId,
        fileArea: route.query.path || '0',
        fileExtendPath: url,
        fileSize: size,
        isFolder: 1,
        fileExtend: file.raw.name.split('.').pop(),
      };

      await store.dispatch('cloud/addFile', params);
      console.log('上传文件成功:', file.raw.webkitRelativePath);
    } catch (e) {
      console.error('上传文件失败:', file.raw.webkitRelativePath, e);
    }
  }
};

async function handleUploadSuccess(e) {
  if (targetMode.value === 'folder') {
    // const {fileName, size, name, url} = e.result;
    // console.log(fileName, size, name, url, e.result, '文件夹')
    // 切割路径获取文件夹
  } else {
    const {fileName, size, name, url} = e.result;
    const params = {
      fileName: name,
      parentId: currentParentId.value, // 使用捕获的 parentId
      filePath: currentParentId.value, // 使用捕获的 parentId
      fileArea: route.query.path ? route.query.path : '0',
      fileExtendPath: url,
      fileSize: size,
      isFolder: 1,
      fileExtend: `${fileName.substring(fileName.lastIndexOf('.') + 1)}`,
    }
    console.log('单文件上传参数:', params)
    await store.dispatch('cloud/addFile', params);
    multipartFiles.value.push(e.result);
    numbers.value++
    console.log(uploadPromises.value.length, fileList.value.length, numbers.value - 1, 'target')
    try {
      await Promise.all(uploadPromises.value)
    } catch (e) {
      console.log(e, 'error')
    } finally {
      if (numbers.value - 1 === fileList.value.length) {
        await resetCurrentAbout()
      }
      await getFileList()
      await store.dispatch("cloud/queryByUserIdApis")
    }
  }
}

onBeforeUnmount(() => {
  clearTimeout(timer.value)
  clearTimeout(clickTimeout.value)
})


// 文件进度
const uploadRefs = ref(null)

function onProgress(progressEvent, file) {
  console.log(uploadRefs.value, '')
  uploadRefs.value.enterList();
  if (fileList.value.filter(item => item.uid === file.uid).length === 0) {
    fileList.value.push(file)
  }
  file.percentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
}


const {type} = defineProps({
  type: {type: Number, default: 1}
})

// 面包屑
const pathArray = ref([
  {path: '0', text: i18n.global.t("common.file.all"), tag: "0"}
])

// 进入文件夹
const tempRouter = ref('')
// 避免用户重复点击
const enterDirectory = throttle(async (row) => {
  tableLoading.value = true
  
  if (type === 4) {
    await store.dispatch('cloud/queryShareFileByParentIdApi', {
      pageNo: current.value,
      pageSize: size.value,
      parentId: row.id
    })
  } else if (type === 2 || type === 3) {
    await store.dispatch("cloud/getFilePathApisShare", {
      pageNo: current.value,
      pageSize: size.value,
      parentId: row.id,
    })
  } else {
    //   请求新的数据
    await store.dispatch("cloud/getFilePathApis", {
      id: row.id,
      type: type === 1 ? type : type === 6 ? 2 : 1,
      pageNo: current.value,
      pageSize: size.value
    })
  }

  const folderId = String(row.id)
  const currentBreadcrumbList = normalizeBreadcrumbList(pathArray.value)
  const existingIndex = currentBreadcrumbList.findIndex(item => item.tag === folderId)
  const nextBreadcrumbList = existingIndex >= 0
      ? currentBreadcrumbList.slice(0, existingIndex + 1)
      : [
        ...currentBreadcrumbList,
        {text: row.fileName, tag: folderId}
      ]
  const syncedBreadcrumbList = syncBreadcrumbState(nextBreadcrumbList)
  const currentBreadcrumb = syncedBreadcrumbList[syncedBreadcrumbList.length - 1]

  console.log('进入文件夹，更新面包屑:', syncedBreadcrumbList)

  // 路由跳转
  await router.push({path: route.path, query: {id: currentBreadcrumb.tag, path: currentBreadcrumb.path}})
  
  tableLoading.value = false
}, TIME_DELAY)


// 单击 弹出 查看文件
const showTargetFile = (row) => {
  let images = [];
  let initialViewIndex = 0;
  // 过滤出非文件夹的文件
  tableData.value.filter(_ => _.isFolder !== 2 && imgFormat.includes(_.fileExtend.toLocaleLowerCase())).forEach((o, i) => {
    if (o.fileName === row.fileName) initialViewIndex = images.length
    images.push({src: o.fileExtendPath?.replace(/^http:\/\//i, "https://") || ""})
  })
  console.log(tableData.value, row.fileName, 'tableData.value')

  viewerApi({
    images,
    options: {
      initialViewIndex
    }
  })
}
// pdf 预览
// 安全替换 http → https，只处理 http:// 开头，不影响 https://
function ensureHttps(url) {
  if (!url) return '';
  return url.replace(/^http:\/\//i, 'https://');
}

// 通用打开文件方法
function openTarget(row, typePath, addTitle = false) {
  if (!row || !row.fileExtendPath || !row.fileExtend) return;

  const url = ensureHttps(row.fileExtendPath);
  const ext = row.fileExtend.toLowerCase();
  let fullPath = `${location.origin}/${typePath}?url=${encodeURIComponent(url)}&type=${encodeURIComponent(ext)}`;

  if (addTitle) {
    fullPath += `&title=${encodeURIComponent(row.fileName)}`;
  }

  openNewWindow(fullPath);
}

// 调用示例
const showTargetPdf = (row) => openTarget(row, 'showfile');
const showTargetText = (row) => openTarget(row, 'showtext');
const showTargetVideo = (row) => openTarget(row, 'showvideo');
const showTargetAudio = (row) => openTarget(row, 'showaudio', true);

const emlPreviewVisible = ref(false);
const emlPreviewAttachment = ref(null);
const showTargetEml = (row) => {
  emlPreviewAttachment.value = {
    name: row.fileName,
    url: row.fileExtendPath,
  };
  emlPreviewVisible.value = true;
};

const openNewWindow = (url) => {
  window.open(url, "_blank");
};


// 多选框select
const selectCheckbox = (selectArray) => {
  console.log('选中的', selectArray)
  activeItem.value = selectArray
}


// 点击 右侧查看文件
const activeItem = ref([])
const showTarget = (row) => {
  console.log(row, '文件')
  activeItem.value = [row];
}

// 单击 右侧查看文件夹
const dirFileList = computed(() => store.state.cloud.dirFileList)
const showLoading = ref(false)
const showTargetDirectory = async (row) => {
  resetCurrentAbout()
  console.log(row.fileName, row.id, '文件夹')
  activeItem.value = [row];
  //  获取内部文件夹列表
  showLoading.value = true
  if (type === 4) {
    // parentId ===0
    await store.dispatch('cloud/queryShareFileByParentIdApi', {
      pageNo: current.value,
      pageSize: size.value,
      show: 1,
      parentId: row.id
    })
  } else if (type === 3 || type === 2) {
    await store.dispatch("cloud/getFilePathApisShare", {
      pageNo: current.value,
      pageSize: size.value,
      parentId: row.id,
      // 是否是 右侧展示的数据
      show: 1
    })
  } else {
    await store.dispatch('cloud/getFilePathApis', {
      id: type === 4 ? row.fileId : row.id,
      type: type === 1 ? type : type === 6 ? 2 : 1,
      show: 1,
      pageNo: current.value,
      pageSize: size.value
    });
  }
  showLoading.value = false;
}


const clickTimeout = ref(false);

// 双击
const selectTargetDetail = (row) => {
  if (row.isFolder === 2) {
    //   文件夹
    //   进入文件夹
    enterDirectory(row);
  } else {
    if (isEmlFile(row.fileName || row.fileExtendPath)) {
      showTargetEml(row);
      return;
    }
    if (!suportFile.value.includes(row.fileExtend.toLocaleLowerCase())) {
      ElMessage.warning("不支持该文件类型在线预览")
      return
    }
    //  文件
    //  弹出 查看文件
    if (imgFormat.includes(row.fileExtend.toLocaleLowerCase())) {
      // 图片预览
      showTargetFile(row)
    }
    if (pdfFormat.includes(row.fileExtend.toLocaleLowerCase())) {
      // pdf
      //预览
      showTargetPdf(row);
    } else if (wordFormat.includes(row.fileExtend.toLocaleLowerCase()) || excelFormat.includes(row.fileExtend.toLocaleLowerCase()) || pptFormat.includes(row.fileExtend.toLocaleLowerCase())) {
      // /world/excel
      window.open("https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(row.fileExtendPath))
    } else if (textFormat.includes(row.fileExtend.toLocaleLowerCase())) {
      showTargetText(row)
    } else if (videoFormat.includes(row.fileExtend.toLocaleLowerCase())) {
      showTargetVideo(row)
    } else if (audioFormat.includes(row.fileExtend.toLocaleLowerCase())) {
      showTargetAudio(row)
    } else {
      // alert('下载')
      downloadTargetFile(row)
    }
  }
}

const suportFile = computed(() => ([...imgFormat, ...pdfFormat, ...wordFormat, ...excelFormat, ...excelFormat, ...videoFormat, ...audioFormat, ...pptFormat, ...textFormat, 'eml']))

// 单击 文件详情展示
const targetFileDetail = (row) => {
  if (row.isFolder === 2) {
    // 右侧 查看文件夹
    showTargetDirectory(row)
  } else {
    // 右侧 查看文件
    showTarget(row)
  }
}

// 记录点击的数量
const clickCount = ref(0);
// 选择点击的事件
const selectClickEvent = (row) => {
  clickCount.value++;
  if (clickCount.value === 1) {
    //   单击事件
    clickTimeout.value = setTimeout(() => {
      multipleTableRef.value.clearSelection()
      multipleTableRef.value.toggleRowSelection(row)
      targetFileDetail(row);
      resetClickCount();
    }, TIME_DELAY)
  } else {
    //   双击事件
    clearTimeout(clickTimeout.value);
    selectTargetDetail(row);
    resetClickCount();
  }
}

const selectClickEventList = (row) => {
  clickCount.value++;
  if (clickCount.value === 1) {
    //   单击事件
    clickTimeout.value = setTimeout(() => {
      targetFileDetail(row);
      resetClickCount();
    }, TIME_DELAY)
  } else {
    //   双击事件
    clearTimeout(clickTimeout.value);
    selectTargetDetail(row);
    resetClickCount();
  }
}

// 重制点击事件
const resetClickCount = () => {
  clickCount.value = 0
}


const handleClick = throttle(async (item, index) => {
  tableLoading.value = true
  refresh.value = !refresh.value
  resetCurrentAbout()
  
  console.log('面包屑点击:', item, 'index:', index, 'pathArray:', pathArray.value)

  // 截取面包屑：保留从根到点击项的所有路径
  const nextBreadcrumbList = syncBreadcrumbState(pathArray.value.slice(0, index + 1))
  console.log('截取后的面包屑:', nextBreadcrumbList)

  // 路由跳转
  const currentBreadcrumb = nextBreadcrumbList[nextBreadcrumbList.length - 1]
  if (currentBreadcrumb.tag !== "0") {
    // 子路由：跳转到指定文件夹
    await router.push({path: route.path, query: {id: currentBreadcrumb.tag, path: currentBreadcrumb.path}})
  } else {
    // 根路由：返回根目录
    await router.push({path: route.path})
  }

  // 刷新文件列表
  await getFileList()
  tableLoading.value = false
}, TIME_DELAY)

function findIndexWithTag(jsonData, flag) {
  for (var i = 0; i < jsonData.length; i++) {
    if (jsonData[i].tag === flag) {
      return i;
    }
  }
  return -1;
}


// 表格
const multipleTableRef = ref(null)
const multipleSelection = computed(() => store.state.customer.multipleSelection)
const handleSelectionChange = async (val) => {
  // multipleSelection.value = val
  console.log(val, 'val')
  endIndex = val.length > 1 ? tableData.value.findIndex(item => item.id === val[val.length - 1].id) : -1;
  const startIndex = val.length > 1 ? tableData.value.findIndex(item => item.id === val[val.length - 2].id) : -1;
  console.log(endIndex, startIndex);
  if (isShiftPressed.value && val.length > 1 && endIndex !== startIndex) {
    const start = startIndex < endIndex ? startIndex : endIndex;
    const end = endIndex < startIndex ? startIndex : endIndex;
    for (let i = start; i <= end; i++) {
      const row = tableData.value[i];
      if (start === i || i === end) {
        continue;
      }
      console.log(row, '更新');
      if (row) {
        multipleTableRef.value.toggleRowSelection(row, true); // 调用表格组件的方法来更新选中状态
      }
    }
    nextTick(async () => {
      await store.commit("cloud/setMultipleSelection", multipleTableRef.value.getSelectionRows())
      console.log(multipleTableRef.value.getSelectionRows(), '当前选中行');
    });
  } else {
    // multipleSelection.value = val;
    await store.commit("cloud/setMultipleSelection", val)
  }
}

// 表格中的数据
const tableLoading = ref(false);
// 数据总表格
// const tableData = ref([])
// 右侧展示的表格
const rightTableDataList = ref([])

const userInfo = computed(() => store.state.user.userInfo);


// 用户是否开始滚动 标识
const scrollStartFlag = ref(false)
const scrollBehavior = () => {
  scrollStartFlag.value = true;
  // console.log(scrollStartFlag.value, 'start-scroll')
}


const gridContainer = ref(false)

const toParentDivEvent = () => {
  if (!gridContainer.value) return
// mouseover 处理鼠标进入
  gridContainer.value.addEventListener('mouseover', (e) => {
    const itemEl = e.target.closest('.grid_item')
    if (itemEl && !dropdownOpen.value) {
      const index = [...itemEl.parentElement.children].indexOf(itemEl)
      if (index >= 0 && index < tableData.value.length) {
        hoverId.value = tableData.value[index].id
      }
    }
  })

  // mouseout 处理鼠标离开
  gridContainer.value.addEventListener('mouseout', (e) => {
    const related = e.relatedTarget
    // 检查是否真正离开了容器
    if (!related || !gridContainer.value.contains(related)) {
      if (!dropdownOpen.value) {
        hoverId.value = null
      }
    }
  })
}


const targetMode = ref('')
const currentParentId = ref('0') // 存储当前上传时的 parentId
const handleUploadModeSelect = (mode) => {
  // 在用户点击上传按钮时，立即捕获当前的 parentId
  currentParentId.value = route.query.id || '0'
  console.log('捕获上传时的 parentId:', currentParentId.value, 'route.query.id:', route.query.id)
  
  nextTick(() => {
    const inputEl = document.querySelector('.upload-demo input[type="file"]')
    if (inputEl) {
      // 上传文件夹
      targetMode.value = mode
      if (mode === 'folder') {
        inputEl.setAttribute('webkitdirectory', true)
        inputEl.setAttribute('directory', true)
      } else {
        // 上传文件
        inputEl.removeAttribute('webkitdirectory')
        inputEl.removeAttribute('directory')
      }
      tempFileBuffer.value = []; // ✅ 清空临时缓存
      inputEl.click() // ✅ 只会在用户操作时触发
      // 缓存单次上传数据
      uploadRefs.value.removeList()
      fileList.value = []
    }
  })
}

onMounted(async () => {
  console.log('组件挂载，当前路由 id:', route.query.id)

  // 初始化面包屑
  checkRouter()
  
  await store.dispatch("cloud/queryByUserIdApis");
  if (route.path !== '/cloud/info') {
    await getFileList();
    multipleTableRef.value && multipleTableRef.value.$refs.bodyWrapper.addEventListener("mousewheel", scrollBehavior, {passive: true})
  }
  toParentDivEvent()
})

onUnmounted(() => {
  multipleTableRef.value && multipleTableRef.value.$refs.bodyWrapper.removeEventListener("mousewheel", scrollBehavior)
  if (gridContainer.value) {
    gridContainer.value.removeEventListener('mouseover', handleMouseOver)
    gridContainer.value.removeEventListener('mouseout', handleMouseOut)
  }
})

// 获取所有数据
const current = ref(1);
const size = ref(40);
const total = computed(() => store.state.cloud.total);

const tableData = computed(() => store.state.cloud.fileList)
const handleCurrentChange = async (page) => {
  current.value = page;
  await getFileList()
}

const getFileList = async () => {
  tableLoading.value = true;
  if (type === 1 || type === 5 || type === 6) {
    console.log('route.query.id', pathArray.value, route.query.id)
    if (route.query.id) {
      checkRouter()
      const params = {
        id: route.query.id,
        type: type === 1 ? type : type === 6 ? 2 : 1,
        pageNo: current.value,
        pageSize: size.value,
        search: searchFile.value ? searchFile.value : ''
      }
      await store.dispatch("cloud/getFilePathApis", params)
    } else {
      const params = {
        pageNo: current.value,
        pageSize: size.value,
        isHide: type === 5 ? 2 : null,
        // 1 我的文件夹， 2 回收站
        type: type === 1 ? type : type === 6 ? 2 : 1,
        parentId: "0",
        search: searchFile.value ? searchFile.value : ''
      }
      if (params.isHide === null) {
        delete params.isHide;
      }
      if (type !== 1) {
        delete params.parentId;
      }
      await store.dispatch('cloud/getFileListApi', params)
    }
  } else if (type === 2) {
    const params = {
      pageNo: current.value,
      pageSize: size.value,
      search: searchFile.value ? searchFile.value : ''
    }
    await store.dispatch("cloud/publicShareOtherListApis", params)
  } else if (type === 3) {
    const params = {
      pageNo: current.value,
      pageSize: size.value,
      search: searchFile.value ? searchFile.value : ''
    }
    await store.dispatch("cloud/myPublicShareListApis", params)
  } else if (type === 4) {
    console.log(route.query.id, 'route.query.id')
    if (route.query.id) {
      checkRouter()
      await store.dispatch('cloud/queryShareFileByParentIdApi', {
        pageNo: current.value,
        pageSize: size.value,
        parentId: route.query.id,
        search: searchFile.value ? searchFile.value : ''
      })
    } else {
      const params = {
        pageNo: current.value,
        pageSize: size.value,
        search: searchFile.value ? searchFile.value : ''
      }
      await store.dispatch("cloud/mailFileShareListApis", params)
    }
  }
  tableLoading.value = false;
}


// table 懒加载
const pages = computed(() => store.state.cloud.pages)
let isFirstPageLoaded = computed(() => store.state.cloud.isFirstPageLoaded);
const refresh = ref(false)
const disabled = computed(() => store.state.cloud.disabled);
/**
 * 文件重命名
 */
const changeVisitable = ref(false);
const changTargetItem = ref({})
const targetFileChange = async (row) => {
  console.log(row, '重命名-row')
  changeVisitable.value = true
  changTargetItem.value = row
}

const closeChangeVisitable = () => {
  changeVisitable.value = false
}

/**
 * 指定文件删除
 */
const targetDeleteList = ref(null)
const targetFileDelete = (row, val) => {
  flags.value = val * 1
  targetDeleteList.value = row;
  deleteVisitable.value = true;
}


/**
 * 取消我的分享
 */
const cancelLoading = ref(false)
const cancelShare = async (row) => {
  if (row.id) {
    activeItem.value = [];
    activeItem.value = [row];
  }
  if (activeItem.value.length === 0) {
    ElMessage.warning(i18n.global.t('sys.tip.select.file'))
    return;
  } else {
    const payload = {
      idList: activeItem.value.map(_ => _.id)
    }
    cancelLoading.value = true;
    await store.dispatch("cloud/fileCancelShareApis", payload)
    await resetGetFileList()
    cancelLoading.value = false;
  }
}

/**
 * copy 分享链接
 */
const copyLink = async (row) => {
  const {shareCode, linkAddress, fileName, shareDay} = row;
  const targetHref = `${window.location.origin}/cloud/download?`
  try {
    await toClipboard(i18n.global.t('displace.cloud.shareLinksTheExtractedCode', {
      fileName,
      shareDay,
      link: `${targetHref}linkAddress=${linkAddress}&shareCode=${shareCode}`,
      code: shareCode
    }))
    ElMessage.success(i18n.global.t('sys.message.success.copy.sharelink'))
  } catch (e) {
    ElMessage.error(i18n.global.t('sys.message.copy.failed'))
  }
}

/**
 * 取消共享
 */
const cancelPublicShare = async () => {
  if (activeItem.value.length === 0) {
    ElMessage.warning(i18n.global.t('sys.tip.select.file'));
    return;
  } else {
    console.log(userInfo.value.userId, 'userInfo.value.userId')
    const payload = {
      fileId: activeItem.value.map(_ => _.id),
    }
    await store.dispatch("cloud/fileCancelPublicShareApis", payload)
    await getFileList()
  }
}

// 监听路由变化，同步更新面包屑
watch([() => route.query.id, () => route.query.path], ([newId, newPath], [oldId, oldPath]) => {
  console.log('路由变化:', oldId, oldPath, '->', newId, newPath)

  if (newId !== oldId || newPath !== oldPath) {
    checkRouter()
  }

  refresh.value = !refresh.value;
})


const toShowTargetFile = (row) => {
//   双击事件
  clearTimeout(clickTimeout.value);
  selectTargetDetail(row);
  resetClickCount();
}


const hoverId = ref(null)
const dropdownOpen = ref(false) // 新增状态跟踪下拉菜单是否打开

// const handleMouseEnter = (item) => {
//   if (!dropdownOpen.value) {
//     hoverId.value = item.id
//   }
// }
// const handleMouseLeave = (event) => {
//   // 检查鼠标是否移入下拉菜单
//   const related = event.relatedTarget
//   if (!related || !event.currentTarget.contains(related)) {
//     if (!dropdownOpen.value) {
//       hoverId.value = null
//     }
//   }
// }

const handleDropdownChange = (visible) => {
  dropdownOpen.value = visible
  if (!visible) {
    // 下拉关闭后延迟一小段时间再隐藏工具栏
    setTimeout(() => {
      if (!dropdownOpen.value) {
        hoverId.value = null
      }
    }, 100)
  }
}


const uploadRefCom = ref(null)
const handleDrop = async (e) => {
  try {
    e.preventDefault();
    
    // 捕获当前的 parentId
    const dropParentId = route.query.id || '0';
    console.log('拖拽上传时的 parentId:', dropParentId, 'route.query.id:', route.query.id);
    
    const items = e.dataTransfer?.items;
    if (!items || items.length === 0) return;

    const fileListArray = [];
    const traverseFileTree = (entry, path = '', fileListArray = []) => {
      return new Promise((resolve) => {
        if (shouldIgnoreFileOrFolder(entry.name)) return resolve();

        if (entry.isFile) {
          entry.file((file) => {
            if (shouldIgnoreFileOrFolder(file.name)) return resolve();

            const newFile = new File([file], file.name, {
              type: file.type,
              lastModified: file.lastModified,
            });

            Object.defineProperty(newFile, 'webkitRelativePath', {
              value: path + file.name,
              writable: false,
              configurable: true,
              enumerable: true,
            });

            newFile.uid = Date.now() + Math.random();
            fileListArray.push(newFile);
            resolve();
          }, (err) => {
            console.warn('读取文件失败', err);
            resolve();
          });

        } else if (entry.isDirectory) {
          const dirReader = entry.createReader();

          const readEntries = () => {
            dirReader.readEntries(async (entries) => {
              if (!entries.length) return resolve();

              await Promise.all(
                  entries.map(ent => traverseFileTree(ent, path + entry.name + '/', fileListArray))
              );

              readEntries(); // 继续读取目录剩余项
            });
          };

          readEntries();
        } else {
          resolve(); // 非文件非目录
        }
      });
    };

    uploadRefs.value.enterList?.();

    // 1. 收集 entry 项
    const entries = [];
    for (let i = 0; i < items.length; i++) {
      const entry = items[i].webkitGetAsEntry?.();
      if (entry) entries.push(entry);
    }

    // 2. 遍历目录树构建文件列表
    await Promise.all(entries.map((entry) => traverseFileTree(entry, '', fileListArray)));

    if (fileListArray.length === 0) {
      ElMessage.warning(i18n.global.t('common.effective.file'));
      return;
    }

    const validDropFiles = filterValidUploadFiles(fileListArray, {checkSpace: false});
    if (!validDropFiles.length) {
      return;
    }

    const totalSize = validDropFiles.reduce((sum, file) => sum + file.size, 0);
    if (!hasEnoughSpace(totalSize)) {
      toBuyDialogVisible.value = true;
      return;
    }

    // 3. 初始化上传 UI 状态
    fileList.value = validDropFiles.map(file => ({
      uid: file.uid,
      name: file.name,
      raw: file,
      percentage: 0,
      status: 'ready',
      isMouseEnter: false
    }));

    // 4. 提取所有文件夹路径
    const allPaths = new Set();
    for (const file of validDropFiles) {
      const pathParts = file.webkitRelativePath.split('/').slice(0, -1);
      let currentPath = '';
      for (const part of pathParts) {
        currentPath = currentPath ? `${currentPath}/${part}` : part;
        allPaths.add(currentPath);
      }
    }

    // 5. 排序路径（父目录在前）
    const sortedPaths = Array.from(allPaths).sort((a, b) => a.split('/').length - b.split('/').length);

    // 6. 创建所有文件夹（递归层级）
    for (const path of sortedPaths) {
      if (folderMap.has(path)) continue;
      const pathParts = path.split('/');
      const part = pathParts[pathParts.length - 1];
      const parentPath = pathParts.length > 1 ? pathParts.slice(0, -1).join('/') : null;

      const parentId = parentPath
          ? folderMap.get(parentPath) || '0'
          : dropParentId; // 使用捕获的 parentId

      const params = {
        isFolder: 2,
        filePath: parentId,
        parentId,
        createTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        fileName: part,
        fileArea: route.query.path || '0',
      };

      try {
        const res = await store.dispatch('cloud/addFile', params);
        folderMap.set(path, res.result);
        console.log(`✅ 创建文件夹: ${path} -> ID: ${res.result}`);
      } catch (e) {
        console.error(`❌ 创建文件夹失败: ${path}`, e);
      }
    }

    // 7. 上传文件
    for (const file of validDropFiles) {
      const folderPath = file.webkitRelativePath.split('/').slice(0, -1).join('/');
      const parentId = folderPath ? (folderMap.get(folderPath) || dropParentId) : dropParentId; // 使用捕获的 parentId

      try {
        const result = await uploadFile(file, (percent) => {
          const idx = fileList.value.findIndex(f => f.uid === file.uid);
          if (idx !== -1) fileList.value[idx].percentage = percent;
        });

        const {fileName, size, name, url, response} = result;

        const idx = fileList.value.findIndex(f => f.uid === file.uid);
        if (idx !== -1) {
          fileList.value[idx] = {
            ...fileList.value[idx],
            status: 'success',
            response,
            url,
            nameSp: name,
            raw: file,
            percentage: 100
          };
        }

        const params = {
          fileName: name,
          parentId,
          filePath: parentId,
          fileArea: route.query.path || '0',
          fileExtendPath: url,
          fileSize: size,
          isFolder: 1,
          fileExtend: fileName.substring(fileName.lastIndexOf('.') + 1),
        };

        await store.dispatch('cloud/addFile', params);
        console.log('📤 上传成功:', file.webkitRelativePath);

      } catch (e) {
        console.error('❌ 上传失败:', file.webkitRelativePath, e);
        ElMessage.error(`${$t('sys.message.error.upload')}: ${file.name}`);
      }
    }

    console.log('📦 最终文件列表:', fileList.value);
  } catch (e) {
    console.error('💥 拖拽上传异常:', e);
    ElMessage.error(i18n.global.t('common.upload.drag'));
  } finally {
    folderMap = new Map();
    await getFileList?.();
  }
};
const handleClickRemoveListReset = () => {
  fileList.value = []
}

const shareDay = ref(5)
const fileName = ref('')
const handleClickShowLink = (val) => {
  console.log(val, 'val')
  const {shareDay: s, fileName: f} = val
  visitableLink.value = true
  shareDay.value = s
  fileName.value = f
}
/**
 * start
 * GRID 布局部分
 */
// 单页全选
const isSelectPage = ref(false)
const handleClickChangeIsSelectPage = async (val) => {
  isSelectPage.value = val

  const updatedList = store.state.cloud.fileList.map(item => ({
    ...item,
    isSelectCheck: val
  }))

  store.commit("cloud/setFileList", updatedList)

  tableData.value.forEach(item => {
    item.isSelectCheck = val;
    if (val) {
      selectedMap.value.set(item.id, item);
    } else {
      selectedMap.value.delete(item.id);
    }
  });
  isIndeterminate.value = false;
  await nextTick()
  activeItem.value = Array.from(selectedMap.value.values()) // ✅ 保证活跃选中项同步
}

let lastSelectedIndex = -1; // 上一次点击的索引
const handleClickChangeFileItem = async (clickedItem, val, index) => {
  const list = [...store.state.cloud.fileList];
  const currentIndex = index;

  // 如果按了 Shift 键且有上一次选中的项
  if (isShiftPressed.value && lastSelectedIndex !== -1 && lastSelectedIndex !== currentIndex) {
    const start = Math.min(lastSelectedIndex, currentIndex);
    const end = Math.max(lastSelectedIndex, currentIndex);

    for (let i = start; i <= end; i++) {
      const item = list[i];
      item.isSelectCheck = true;
      selectedMap.value.set(item.id, item);
    }
  } else {
    // 普通点击单选/取消
    const targetItem = list.find(item => item.id === clickedItem.id);
    if (targetItem) {
      targetItem.isSelectCheck = val;
      if (val) {
        selectedMap.value.set(clickedItem.id, clickedItem);
      } else {
        selectedMap.value.delete(clickedItem.id);
      }
    }
    lastSelectedIndex = currentIndex; // 更新记录
  }

  store.commit("cloud/setFileList", list);
  tableData.value.forEach(item => {
    item.isSelectCheck = selectedMap.value.has(item.id);
  });
  updateSelectPageStatus();
  await nextTick();
  activeItem.value = Array.from(selectedMap.value.values());
  isSelectPage.value = list.length > 0 && list.every(item => item.isSelectCheck);
};

const isIndeterminate = ref(false); // 是否半选
// 更新状态
const updateSelectPageStatus = () => {
  const currentPageIds = tableData.value.map(item => item.id);
  const selectedInCurrentPage = currentPageIds.filter(id => selectedMap.value.has(id));

  const selectedCount = selectedInCurrentPage.length;
  const total = tableData.value.length;

  if (selectedCount === 0) {
    isSelectPage.value = false;
    isIndeterminate.value = false;
  } else if (selectedCount === total) {
    isSelectPage.value = true;
    isIndeterminate.value = false;
  } else {
    isSelectPage.value = false;
    isIndeterminate.value = true; // ✅ 半选状态
  }
};


const selectedMap = ref(new Map()); // key: 文件唯一id，value: 文件对象
watch(tableData, () => {
  tableData.value.forEach(item => {
    item.isSelectCheck = selectedMap.value.has(item.id); // 设置是否勾选
  });
  updateSelectPageStatus(); // 更新是否全选/半选状态
});


const selectedFiles = computed(() => {
  return Array.from(selectedMap.value.values());
});
/**
 * end
 * GRID 布局部分
 */


onMounted(() => {
  // Shift监听/取消监听
  document.addEventListener('keydown', handleKeyDown);
  document.addEventListener('keyup', handleKeyUp);
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
  document.removeEventListener('keyup', handleKeyUp);
});

let endIndex = -1;
// table 选择增加 shift
const isShiftPressed = ref(false); // 标记 Shift 键是否被按下
const handleKeyDown = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    // console.log("进来了-----------------", event.key, event.keyCode);
    isShiftPressed.value = true;
  }
};

const handleKeyUp = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    isShiftPressed.value = false;
  }
};


const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  // console.log(row, columnIndex)
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 4 || columnIndex === 5) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 4 || columnIndex === 5) {
    return {'text-align': 'left', padding: '8px 0px'}
  } else {
    return {'text-align': 'center', padding: '8px 0px'}
  }
}

</script>

<style lang="less" scoped>
@import "./index";

:deep(.el-empty__image img) {
  width: 54% !important;
}

:deep(.el-empty__description) {
  margin-top: -20px;
}

:deep(.el-upload-dragger) {
  padding: 0px !important;
  border: none !important;
}

.sp_des {
  word-break: break-all;
  color: #878c9c;
  font-size: 14px;
  margin-bottom: 10px;
}

#pages_com {
  margin-top: 5px;
  display: flex !important;
  justify-content: flex-end !important;
  height: max-content !important;
}

.previewfile {
  & > span {
    display: inline-flex !important;
    justify-content: flex-start !important;
    width: 400px !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }
}

.top_select {
  color: #919398 !important;
  margin: 2px 0px 0px 12px;
}

.grid_item {
  position: relative;

  .check_left_top_box {
    position: absolute;
    left: 10px;
    top: 2px;
  }
}

:deep(.el-breadcrumb__inner) {
  font-size: 13px !important;
}

:deep(.el-checkbox__label) {
  font-size: 13px !important;
  font-weight: 500 !important;
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}

.text {
  font-size: 13px !important;
  font-weight: normal !important;
}

:deep(.el-dropdown-menu__item) {
  width: 120px !important;
  justify-content: center !important;
}

:deep(.el-dropdown__popper) {
  padding: 0px !important;
}
</style>
